import { render } from "./InventorySourceImportHistory.vue?vue&type=template&id=fd92de88"
import script from "./InventorySourceImportHistory.vue?vue&type=script&lang=js"
export * from "./InventorySourceImportHistory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/51/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge});
